// app/javascript/controllers/carousel_controller.js
//
// Scroll-progress dots for the mobile scroll-snap carousels on the
// /for-farmers landing page (trust strip, testimonials). Pure CSS
// handles the snapping and the edge-peek; this controller only keeps
// the little progress dots in sync with the scroll position and lets a
// tap on a dot scroll to that card. Desktop renders a grid, so the
// carousel markup is display:none there and this controller stays idle.
//
// No new dependencies — plain Stimulus, matching the rest of the app.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "dot"]

  connect() {
    this.onScroll = this.onScroll.bind(this)
    this.trackTarget.addEventListener("scroll", this.onScroll, { passive: true })
    this.updateActiveDot()
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    // Coalesce scroll events into one update per animation frame.
    if (this.frame) return
    this.frame = requestAnimationFrame(() => {
      this.frame = null
      this.updateActiveDot()
    })
  }

  // Jump to the card that matches the tapped dot.
  scrollTo(event) {
    const index = Number(event.currentTarget.dataset.index)
    const card = this.trackTarget.children[index]
    if (card) {
      this.trackTarget.scrollTo({ left: card.offsetLeft - this.trackTarget.offsetLeft, behavior: "smooth" })
    }
  }

  updateActiveDot() {
    if (!this.hasDotTarget) return
    const track = this.trackTarget
    const center = track.scrollLeft + track.clientWidth / 2

    // The active card is the one whose horizontal centre is nearest the
    // viewport centre of the track.
    let activeIndex = 0
    let nearest = Infinity
    Array.from(track.children).forEach((card, i) => {
      const cardCenter = card.offsetLeft - track.offsetLeft + card.clientWidth / 2
      const distance = Math.abs(cardCenter - center)
      if (distance < nearest) {
        nearest = distance
        activeIndex = i
      }
    })

    this.dotTargets.forEach((dot, i) => {
      const active = i === activeIndex
      dot.classList.toggle("bg-primary", active)
      dot.classList.toggle("w-5", active)
      dot.classList.toggle("bg-primary/25", !active)
      dot.classList.toggle("w-2", !active)
    })
  }
}
